import { ComponentProps } from "react";
import { cn } from "../../../lib/utils";
import { Search } from "lucide-react";

export type InputProps = ComponentProps<"input"> & {
  inputError?: string;
  isSearch?: boolean;
};

/** @deprecated Use AppInput instead */
function Input({ className, type, inputError, isSearch = false, ...props }: InputProps) {
  return (
    <div className="relative flex-1">
      {isSearch && <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 w-4 h-4" />}

      <input
        type={type}
        data-slot="input"
        className={cn(
          "border-input file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-[14px] shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          "[&.invalid]:border-errorRed",
          !!inputError && "invalid",
          className
        )}
        {...props}
      />
      {inputError && <p className="text-destructive text-sm">{inputError}</p>}
    </div>
  );
}

export { Input };
